import './App.scss';
import RouterComponent from './App/RouterComponent/RouterComponent';

function App() {
  return (
    <div className="App">
      <RouterComponent />
    </div>
  );
}

export default App;
